import React from 'react';
import { AllieText, AllieSearchableSelect, DarkTooltip } from '../../../../components';
import { Filter } from '../FilterBar';

interface SearchableFilterProps {
  filter: Omit<Filter, 'type'>;
  labelAll: string;
  options: { text: string; value: string }[] | undefined;
  namespace: string;
}

export const SearchableFilter: React.FC<SearchableFilterProps> = ({
  filter,
  labelAll,
  options,
  namespace,
}) => {
  const {
    label,
    handleChange,
    selected,
    multiple,
    filterLabelAll,
    searchPlaceholder,
    includeAllOption,
    showTooltip,
    tooltipText,
    tooltipSide = 'bottom',
    tooltipAlignment = 'end',
    virtualized,
    'data-testid': dataTestId,
  } = filter;

  const getSelectedValue = (value: string | number | (string | number)[]) => {
    if (Array.isArray(value)) {
      const selecteds = options?.filter((option) => value.includes(option.value));
      return selecteds
        ?.map((option) => option.text)
        .filter((text): text is string => text !== undefined);
    }
    if (String(value).includes(',')) {
      return String(value)
        .split(',')
        .map((option) => options?.find((opt) => opt.value === option)?.text.trim())
        .filter((text): text is string => text !== undefined);
    }
    const option = options?.find((o) => o.value === value || o.value === String(value));
    return option ? [option.text] : (filterLabelAll || labelAll);
  };

  return (
    <div className={`${namespace}__item`} data-testid={dataTestId}>
      <AllieText
        className={`${namespace}__label`}
        type="body3"
        weight={400}
        color="neutral-50"
      >
        {label}
      </AllieText>
      <DarkTooltip 
        text={tooltipText || ''} 
        side={tooltipSide}
        alignment={tooltipAlignment}
        disabled={!showTooltip || !tooltipText}
      >
        <AllieSearchableSelect
          className={`${namespace}__item__searchable`}
          handleOnSelect={(value) => handleChange({ detail: { value } })}
          options={options || []}
          selectedValue={getSelectedValue(selected)}
          multiple={multiple}
          placeholder={filterLabelAll || labelAll}
          searchPlaceholder={searchPlaceholder}
          popoverProps={{
            size: 'auto',
            side: 'bottom',
            alignment: 'end',
          }}
          selectAllLabel={
            includeAllOption ? (filterLabelAll || labelAll) : undefined
          }
          virtualized={virtualized}
        />
      </DarkTooltip>
    </div>
  );
}; 